import actions from '@/store/modules/resetPassword/actions';
import mutations from '@/store/modules/resetPassword/mutations';

const state = {
  request: {
    loading: false,
  },
  reset: {
    loading: false,
    validating: true,
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
